export default {
  title: 'Loyalty program',
};
